import { addEventListeners } from './utils/events'
import { TimelineLite, Power2 } from 'gsap'
import bus from './bus'
import icons from './animated-icons'
import lottie from 'lottie-web'
import scrollDir from 'scrolldir'
import toggleClass from './utils/toggleClass'
import UI from './utils/UI'

UI({
  component: '.js-siteHeader',
  drawerToggle: '.js-siteHeader-drawerToggle',
  inset: '.js-siteHeader-inset',
  actions: '.js-siteHeader-actions',
  logo: '.js-siteHeader-logo',
  hamburger: '.js-siteHeader-drawerToggleHamburger',
  cross: '.js-siteHeader-drawerToggleCross',
  shopLink: '.js-siteHeader-shopLink'
}, ({ component, drawerToggle, logo, inset, actions, hamburger, cross, shopLink }) => {
  let isDrawerOpen = false
  scrollDir({ el: component, dir: 'up' })
  const tl = new TimelineLite({ onComplete: _ => bus.emit('site-header-ready') })
  tl.from(logo, 0.25, { y: -170, rotation: -20, ease: Power2.easeOut }, '+=0.2')
  tl.from(inset, 0.35, { y: -120, rotation: 20, ease: Power2.easeOut }, '-=0.25')
  tl.from(actions, 0.35, { x: 200, ease: Power2.easeOut }, '-=0.25')
  tl.from(drawerToggle, 0.35, { x: 200, ease: Power2.easeOut }, '-=0.1')
  if (shopLink) {
    tl.from(shopLink, 0.35, { x: 200, ease: Power2.easeOut }, '-=0.1')
  }

  drawerToggle.addEventListener('click', evt => {
    evt.preventDefault()
    isDrawerOpen = !isDrawerOpen
    toggleClass(component, 'is-drawerOpen', isDrawerOpen)
    bus.emit('is-drawer-open', isDrawerOpen)
  }, false)

  const sharedSettings = { renderer: 'svg', loop: false, autoplay: false }

  const hamburgerAnimation = lottie.loadAnimation({
    ...sharedSettings,
    container: hamburger,
    animationData: icons.hamburger
  })

  const crossAnimation = lottie.loadAnimation({
    ...sharedSettings,
    container: cross,
    animationData: icons.cross
  })

  addEventListeners(drawerToggle, 'mouseenter focus', _ => {
    if (window.IS_TOUCH_DEVICE) {
      return
    }

    hamburgerAnimation.play()
    crossAnimation.play()
  }, false)

  addEventListeners(drawerToggle, 'mouseleave blur', _ => {
    if (window.IS_TOUCH_DEVICE) {
      return
    }

    hamburgerAnimation.stop()
    crossAnimation.stop()
  }, false)
})
